<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Self-Help Tools</h2>

        <small class="text-muted">Manage all your Self-Help Tools here. </small>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Create
          Self-Help Tools
        </span>
      </base-button>
    </div>
    <SelfhelpTable />
  </b-card>
</template>

<script>
import SelfhelpTable from "./components/SelfhelpTable.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      categoryId: null,
      categoryName: null,
    };
  },
  components: {
    SelfhelpTable,
  },

  methods: {
    handleAdd() {
      this.$router.push({ name: "addselfhelp" });
    },
    // async init() {
    //   await this.$store.dispatch("cms/getListings");
    //   await this.$store.dispatch("cmstag/getTags");
    //   // const params = new URLSearchParams();
    //   // params.append(
    //   //   "filter",
    //   //   JSON.stringify({
    //   //     listing: this.listings[0]._id,
    //   //   })
    //   // );
    //   await this.$store.dispatch("cms/getPageCategories");

    //   this.pageCategories.forEach((element) => {
    //     if (element.route.includes("self-help-tools")) {
    //       console.log(element);
    //       this.categoryId = element._id;
    //       this.categoryName = element.name;
    //     }
    //   });

    //   const { data } = await this.$store.dispatch("cms/getpagebycategory", {
    //     id: this.categoryId,
    //   });
    //   console.log(data);
    // },
  },
  // mounted() {
  //   this.init();
  // },
};
</script>
